import { Button, FormGroup, InputLabel, OutlinedInput } from '@mui/material'
import { useFormik } from 'formik'
import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { BeatLoader } from 'react-spinners'
import { Container, ContainerForm, ContainerFormRight, Title } from '../../styles/index.sty';
import AlertSnack from '../../components/Alert/AlertSnack'
import { useAuth } from '../../context/authContext'
import { useLists } from '../../context/listContext'
import { insertProductCategoryBarData, updateProductCategoryBarData } from '../../api/product-categories-bar.api'

export const AddProductCategoryBar = () => {
  const { config2 } = useAuth();
  const { fetchProductCategoriesBarList } = useLists();
  const navigate = useNavigate();
  const location = useLocation();
  const prodCatBar = location?.state?.data;
  const [ loading, setLoading ] = useState(false);
  const [open, setOpen] = useState(false);
  const [ response, setResponse ] = useState({});
  const [ file, setFile ] = useState(null);
  const formik = useFormik({
    initialValues: {
    product_category_bar_name: prodCatBar?.product_category_bar_name,
    product_category_bar_description: prodCatBar?.product_category_bar_description
    },
    onSubmit: async values => {
      setLoading(true);
      if (prodCatBar) {
        const submit = await updateProductCategoryBarData({...values, file, image_name: prodCatBar.product_category_bar_image_name, product_category_bar_id: prodCatBar?.product_category_bar_id }, config2);
        setResponse(submit);
        fetchProductCategoriesBarList();
        setOpen(true);
        if(submit.status === "success") {
          navigate("/product-categories-bars");
        }
      } else {
        const submit = await insertProductCategoryBarData({...values, file}, config2);
        setResponse(submit);
        fetchProductCategoriesBarList();
        setOpen(true);
        if(submit.status === "success") {
          navigate("/product-categories-bars");
        }
      }
    },
  });

  return (
    <>
    <Container>
      <Title variant='h5' className='w-[100%]'>Enter Product Category Bar Details.</Title>
      <ContainerForm>
      {open && <AlertSnack open={open} setOpen={setOpen} response={response} setLoading={setLoading} route="customers"/>}

      {loading ?
        <div className='items-center'>
          <BeatLoader color="#36d7b7" />
        </div>
        :
      <div style={{width : "60%", margin: "auto"}} >
        <FormGroup>
          <InputLabel htmlFor="product_category_bar_name">Category Bar Name:<span className='text-[red]'>** </span> </InputLabel>
          <OutlinedInput
            name="product_category_bar_name"
            placeholder="Enter Product Category Name"
            id="product_category_bar_name"
            type="text"
            value={formik.values.product_category_bar_name}
            onChange={formik.handleChange}
            />
        </FormGroup><br/>
        <FormGroup>
          <InputLabel htmlFor="product_category_bar_description">Category Bar Description: </InputLabel>
          <OutlinedInput
            name="product_category_bar_description"
            placeholder="Enter Product Category Description"
            id="product_category_bar_description"
            type="text"
            value={formik.values.product_category_bar_description}
            onChange={formik.handleChange}
            />
        </FormGroup><br/>
        <FormGroup>
          <InputLabel htmlFor="file">Category bar Image:<span className='text-[red]'>** </span> </InputLabel>
          <OutlinedInput
            name="file"
            placeholder="Select Image"
            id="file"
            type="file"
            // value={file}
            onChange={(e) => setFile(e.target.files[0])}
            />
        </FormGroup>
        <div className='flex flex-row justify-between'>
          <Button
            type="button"
            variant='contained'
            color='info'
            onClick={() => navigate("/product-categories-bars")}
            style={{
              marginTop: "1rem",
              width: "48%"
            }}
            >
            Back
          </Button>
          <Button
            type="button"
            variant='contained'
            color='info'
            onClick={formik.handleSubmit}
            style={{
              marginTop: "1rem",
              width: "48%"
            }}
            >
            Save & Continue
          </Button>
        </div>
        {/* <Button
          fullWidth
          type="button"
          variant='contained'
          color='info'
          onClick={logList}
          style={{
            margin: "1rem auto"
          }}
          >
          Click Me TO Check
        </Button> */}
        </div>}
      </ContainerForm>
        <ContainerFormRight>
          <div className="flex flex-wrap">
            <p className="text-2xl mb-4 w-[100%]">
              <b>Image Preview</b>
            </p>
            <hr />
            {location?.pathname.includes("update") ? (
              <div className="w-[50%] mb-12">
                <p className="text-xl mb-4">
                  <b>Old Image</b>
                </p>
                <img
                  className=" m-auto"
                  src={prodCatBar?.product_category_bar_image_file}
                  alt={prodCatBar?.product_category_bar_image_name}
                />
              </div>
            ) : null}
            <div className="w-[50%]">
              <p className="text-xl mb-4">
                <b>New Image</b>
              </p>
              {file ? (
                <img
                  className=" m-auto"
                  src={URL.createObjectURL(file)}
                  alt={prodCatBar?.product_category_bar_image_name}
                />
              ) : (
                <p>No Image Selected</p>
              )}
            </div>
          </div>
        </ContainerFormRight>
    </Container>
    </>
  )
};
